import { render, staticRenderFns } from "./calendarComponent.vue?vue&type=template&id=10c4d280&"
import script from "./calendarComponent.vue?vue&type=script&lang=js&"
export * from "./calendarComponent.vue?vue&type=script&lang=js&"
import style0 from "./calendarComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports